import { useEffect, useState } from 'react';

function useMouseDown() {
  const [active, setActive] = useState<boolean>(false);

  const handleMouseDown = () => setActive(true);
  const handleMouseUp = () => setActive(false);

  useEffect(() => {
    window.addEventListener('mousedown', handleMouseDown);
    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mousedown', handleMouseDown);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  return active;
}

export default useMouseDown;
